/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;position:relative;height:100%}.outerwrap[_ngcontent-%COMP%]{height:100%}a.mat-raised-button[_ngcontent-%COMP%]{margin-left:20px}[_nghost-%COMP%]     .mat-dialog-actions{bottom:0;position:absolute;width:100%}.actionbar[_ngcontent-%COMP%]{margin-bottom:15px}.bottomactionbar[_ngcontent-%COMP%]{margin-top:15px}.scroll[_ngcontent-%COMP%]{overflow-y:auto}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/services/dialogs/notification/notification.dialogcomponent.css.shim.ngstyle.js.pre-build-optimizer.js